import setFolderMruConfigurationService from '../services/setFolderMruConfigurationService';
import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';

/**
 * Action to remove a folderId fromn Mru list and save it to server
 * @param folderId - folderIs to remove from mru list
 */
export default action('removeFolderIdFromMoveToMruList')(function removeFolderIdFromMoveToMruList(
    folderId: string
) {
    const mruStore = getStore();
    const index = mruStore.mruFolders.indexOf(folderId);

    if (index < 0) {
        return;
    }

    mruStore.mruFolders.splice(index, 1);

    if (mruStore.isInitialized) {
        setFolderMruConfigurationService(mruStore.mruFolders);
    }
});
